import React, { useCallback, useMemo } from "react";
import { Rnd } from "../dragAndDrop/dragAndDrop";
import { colors } from "../../constants/colors";
import ButtonCustom from "../button/buttonCustom";

type ZoneBoxProps = {
  index: number;
  x: number | string;
  y: number | string;
  width: number | string;
  height: number | string;
  zoneName: string;
  bgColor: string;
  isSelected: boolean;
  enableResizing: boolean;
  disableDragging: boolean;
  dragGrid: any;
  /** true = ส่งค่าตอนปล่อยเมาส์ (onResizeStop) แทนที่จะส่งทุก tick ของ onResize */
  commitOnStop?: boolean;
  onSelect: (index: number) => void;
  onManage: (index: number) => void;
  onDragStop: (index: number, d: any) => void;
  onResizeCommit: (index: number, ref: any, position: any) => void;
};

/** เหตุผลเดียวกับ StallBox — ดู comment ในไฟล์นั้น */
function ZoneBoxBase(props: ZoneBoxProps) {
  const {
    index, x, y, width, height, zoneName, bgColor, isSelected,
    enableResizing, disableDragging, dragGrid, commitOnStop,
    onSelect, onManage, onDragStop, onResizeCommit,
  } = props;

  const style = useMemo(
    () => ({
      border: `solid 1px ${isSelected ? colors.danger : colors.divider}`,
      backgroundColor: `${bgColor}`,
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "center",
      justifyContent: "center",
    }),
    [bgColor, isSelected]
  );

  const size = useMemo(() => ({ width, height }), [width, height]);
  const position = useMemo(() => ({ x, y }), [x, y]);

  const handleClick = useCallback(() => onSelect(index), [onSelect, index]);
  const handleManage = useCallback(() => onManage(index), [onManage, index]);

  const handleDragStop = useCallback(
    (e: any, d: any) => {
      e.stopPropagation();
      onDragStop(index, d);
    },
    [onDragStop, index]
  );

  const handleResize = useCallback(
    (_e: any, _direction: any, ref: any, _delta: any, pos: any) =>
      onResizeCommit(index, ref, pos),
    [onResizeCommit, index]
  );

  return (
    <Rnd
      onClick={handleClick}
      style={style}
      bounds="parent"
      size={size as any}
      position={position as any}
      onDragStop={handleDragStop}
      {...(commitOnStop
        ? { onResizeStop: handleResize }
        : { onResize: handleResize })}
      enableResizing={enableResizing}
      disableDragging={disableDragging}
      dragGrid={dragGrid}
    >
      <div>{zoneName}</div>
      <div className="pt-2">
        <ButtonCustom textButton="จัดการโซน" onClick={handleManage} />
      </div>
    </Rnd>
  );
}

export default React.memo(ZoneBoxBase);
